import React from 'react';
import PropTypes from 'prop-types';
import ChampDeTexte from '../../UI/ChampDeTexte/ChampDeTexte';
import MessageErreur, {
  classeChampEnErreur,
} from '../../UI/MessageErreur/MessageErreur';
import S from '../ProfilTasks/FormulaireTasks/FormulaireTasks.module.scss';

/**
 * Section d'informations de base de la tâche (nom)
 *
 * erreur est une clé de traduction issue du schéma. Elle était jusqu'ici
 * passée à ChampDeTexte, qui ne la gère pas et la posait telle quelle en
 * attribut de l'input : aucun message ne s'affichait.
 */
const TaskBasicInfo = ({ nom, erreur, onChange, readOnly = false }) => {
  return (
    <div className={S.section}>
      <h4 className={S.sousTitre}>Informations de la tâche</h4>
      <div className={S.champGroupe}>
        <label className={S.label}>Nom de la tâche *</label>
        <ChampDeTexte
          value={nom}
          onChange={(v) => onChange('nom', v)}
          placeholder="Nom de la tâche"
          name="nom"
          className={erreur ? classeChampEnErreur : ''}
          disabled={readOnly}
        />
        <MessageErreur cle={erreur} />
      </div>
    </div>
  );
};

TaskBasicInfo.propTypes = {
  nom: PropTypes.string.isRequired,
  erreur: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

TaskBasicInfo.defaultProps = {
  erreur: null,
  readOnly: false,
};

export default React.memo(TaskBasicInfo);
